export default __webpack_public_path__ + "static/media/preview-icon.7bd33578.svg";